export const Arrow = ({
    toTop,
    className,
    arrowSrc,
}: {
    toTop: boolean;
    className?: string;
    arrowSrc?: string;
}) => {
    return (
        <img
            src={arrowSrc ?? '/icon/Arrow.svg'}
            alt="Arrow"
            className={`
            transition-[all_0.8s_ease_0s]
            ${toTop && 'rotate-180'}
            ${className || ''}`}
        />
    );
};
